<script setup lang="ts">
import { Toaster } from '@manta/ui-kit';
</script>

<template>
  <Toaster />
  <RouterView />
</template>
